/**
 * Feature Flags
 * 
 * Toggle features on/off without code changes.
 * To re-enable the paywall, simply set PAYWALL_ENABLED to true.
 */

// When false, all logged-in users get full access to all stories/episodes.
// When true, only users with user.premium === true get full access.
export const PAYWALL_ENABLED = true;
